export class RestaurantRankingFormat {
    public constructor(
        public name: string,
        public place_id: string,
        public vicinity?: string,
        public formatted_address?: string
    ) {}
}
